import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Spin, Input, Select, Col, Row, Upload, Button, Icon,
} from 'antd';
import { Link } from 'react-router-dom';
import { changeUserProfileRequest } from '../redux/actions/user_profile_actions/change_user_profile.actions';
import { changeUserAvatarRequest } from '../redux/actions/change_user_avatar.actions';
import { generateUserAPITokenRequest } from '../redux/actions/generate_user_api_token.actions';
import { validation_rules } from '../../../../shared/validation_rules';
import { digitAndDashValidation, getVal } from '../../../../shared/helpers';

const mapStateToProps = (state) => {
    const { profile, options } = state.UserManagement.User_profile.User_profile_table;
    return {
        profile,
        options,
        user_groups: getVal(state, 'App.App_content.user.groups'),
    };
}; const { Option } = Select; const
    validation_message = { color: 'red', fontStyle: 'italic', fontSize: 12 };

export default connect(mapStateToProps, null)(class ProfileMain extends Component {
    state = {
        email_validation_message: '',
        extension_number_validation: '',
        first_name_validation: '',
        last_name_validation: '',
    };

    changeProfileData = ({ target }) => {
        this.props.dispatch({ type: 'USER_PROFILE_CHANGE_DATA_HANDLER', [target.name]: target.value });
    };

    handleLoginChangeValidation = (event) => {
        if (!validation_rules.email(event.target.value) && !validation_rules.createUserEmail(event.target.value)) {
            this.props.dispatch(changeUserProfileRequest({ key: event.target.name, value: event.target.value, _id: this.props.profile._id }));
            this.setState({ email_validation_message: '' });
        } else {
            this.setState({ email_validation_message: validation_rules.email(event.target.value) || validation_rules.createUserEmail(event.target.value) });
        }
    };

    handleProfileChanges = (key, value) => {
        const { profile: { _id }, dispatch } = this.props; const
            data = typeof value === 'undefined' ? key.target.name : value.props.title;
        if (/ref_prefix_name|ref_department/i.test(data)) {
            dispatch(changeUserProfileRequest({ key: data, value: key, _id }));
        } else if (data === 'extension_number') {
            if (digitAndDashValidation(key.target.value)) {
                this.setState({ extension_number_validation: '' });
                dispatch(changeUserProfileRequest({ key: data, value: key.target.value, _id }));
            } else if (!key.target.value.length) {
                this.setState({ extension_number_validation: 'Field should not be empty' });
            } else {
                this.setState({ extension_number_validation: 'This field must contain only digits' });
            }
        } else if (data === 'first_name') {
            if (!key.target.value.length) {
                this.setState({ first_name_validation: 'Field should not be empty' });
            } else {
                this.setState({ first_name_validation: '' });
                dispatch(changeUserProfileRequest({ key: data, value: key.target.value, _id }));
            }
        } else if (data === 'last_name') {
            if (!key.target.value.length) {
                this.setState({ last_name_validation: 'Field should not be empty' });
            } else {
                this.setState({ last_name_validation: '' });
                dispatch(changeUserProfileRequest({ key: data, value: key.target.value, _id }));
            }
        } else {
            dispatch(changeUserProfileRequest({ key: data, value: key.target.value, _id }));
        }
    };

    fileChangedHandler = (event) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(event.file);
        fileReader.addEventListener('load', () => this.props.dispatch(changeUserAvatarRequest(this.props.profile._id, fileReader.result)));
    };

    generateUserAPIToken = () => {
        this.props.dispatch(generateUserAPITokenRequest({ user_id: this.props.id }));
    };

    render() {
        const { options, profile } = this.props;

        let is_user_admin_or_super_user = false;

        if (this.props.user_groups) {
            // admin group id "5b6a9ee2ba52006858939023"
            // super user group id "5b6a9ee2ba52006858939024"

            is_user_admin_or_super_user = this.props.user_groups.some(group => group._id === '5b6a9ee2ba52006858939023' || group._id === '5b6a9ee2ba52006858939024');
        }

        return !profile
            ? (
                <Spin tip="Profile is loading...">
                    <div style={{ minHeight: '30vh' }} />
                </Spin>
            )
            : (
                <Fragment>
                    <Row>
                        <Col span={11}>
                            <div className="user_profile_top_label">Prefix Name</div>
                            <Select
                                style={{ width: '100%' }}
                                value={profile.person.ref_prefix_name ? profile.person.ref_prefix_name.name : ''}
                                onChange={this.handleProfileChanges}
                            >
                                {options.prefixes.map(prefix => <Option key={prefix._id} title="ref_prefix_name" value={prefix._id}>{prefix.name}</Option>)}
                            </Select>
                            <div className="user_profile_label">First Name</div>
                            <Input
                                name="first_name"
                                autoComplete="off"
                                placeholder="Enter first name"
                                value={profile.person.first_name}
                                onChange={this.changeProfileData}
                                onBlur={this.handleProfileChanges}
                            />
                            <span style={validation_message}>{this.state.first_name_validation}</span>
                            <div className="user_profile_label">Last Name</div>
                            <Input
                                name="last_name"
                                autoComplete="off"
                                placeholder="Enter last name"
                                value={profile.person.last_name}
                                onChange={this.changeProfileData}
                                onBlur={this.handleProfileChanges}
                            />
                            <span style={validation_message}>{this.state.last_name_validation}</span>
                            <div className="user_profile_label">Extension Number</div>
                            <Input
                                name="extension_number"
                                autoComplete="off"
                                placeholder="Enter Extension Number"
                                value={profile.person.extension_number}
                                onChange={this.changeProfileData}
                                onBlur={this.handleProfileChanges}
                            />
                            <span style={validation_message}>{this.state.extension_number_validation}</span>

                            {is_user_admin_or_super_user && <Button type="primary" onClick={this.generateUserAPIToken} style={{ marginTop: 20 }}>Generate API Token</Button>}
                        </Col>
                        <Col span={11} offset={2}>
                            <div className="user_profile_top_label">Department</div>
                            <Select
                                style={{ width: '100%' }}
                                value={profile.person.ref_department ? profile.person.ref_department.name : ''}
                                onChange={this.handleProfileChanges}
                            >
                                {options.departments.map(department => <Option key={department._id} title="ref_department" value={department._id}>{department.name}</Option>)}
                            </Select>
                            <div className="user_profile_label">Login</div>
                            <Input
                                name="login"
                                placeholder="example@mail.com"
                                value={profile.login}
                                onChange={this.changeProfileData}
                                onBlur={this.handleLoginChangeValidation}
                            />
                            <span style={validation_message}>{this.state.email_validation_message}</span>
                            <div className="user_profile_label">Avatar</div>
                            <Upload showUploadList={false} customRequest={this.fileChangedHandler} accept="image/*">
                                <Button>
                                    <Icon type="upload" />
                                    {' '}
                                    Click to Upload Avatar
                                </Button>
                            </Upload>
                        </Col>
                    </Row>
                    <Link to="/UserManagement/User_list">
                        <Button style={{ float: 'right' }}>Back to Users List</Button>
                    </Link>
                </Fragment>
            );
    }
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/components/ProfileMain.js